export const documentOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M13.1 3.89996H10.6C9.60503 3.89996 8.91295 3.90067 8.37447 3.94466C7.8465 3.9878 7.54593 4.06803 7.3196 4.18335C6.83038 4.43262 6.43263 4.83037 6.18336 5.31959C6.06804 5.54592 5.98781 5.84649 5.94467 6.37446C5.90068 6.91294 5.89998 7.60502 5.89998 8.59997V15.4C5.89998 16.3949 5.90068 17.087 5.94467 17.6255C5.98781 18.1534 6.06804 18.454 6.18336 18.6803C6.43263 19.1696 6.83038 19.5673 7.3196 19.8166C7.54593 19.9319 7.8465 20.0121 8.37447 20.0553C8.91295 20.0993 9.60503 20.1 10.6 20.1H14.4C15.3949 20.1 16.087 20.0993 16.6255 20.0553C17.1535 20.0121 17.454 19.9319 17.6804 19.8166C18.1696 19.5673 18.5673 19.1696 18.8166 18.6803C18.9319 18.454 19.0121 18.1534 19.0553 17.6255C19.0993 17.087 19.1 16.3949 19.1 15.4V9.89996H17.2L17.1646 9.89997C16.6347 9.89998 16.1835 9.89999 15.8131 9.86973C15.4239 9.83793 15.0453 9.7683 14.6834 9.58388C14.1377 9.30585 13.6941 8.86221 13.4161 8.31654C13.2316 7.9546 13.162 7.57601 13.1302 7.18685C13.0999 6.81642 13.1 6.36524 13.1 5.83537L13.1 5.79997V3.89996ZM18.3272 8.09997L14.9 4.67276V5.79997C14.9 6.37487 14.9007 6.75192 14.9242 7.04027C14.9469 7.31812 14.9863 7.43346 15.0199 7.49935C15.1253 7.70633 15.2936 7.87461 15.5006 7.98007C15.5665 8.01365 15.6818 8.053 15.9597 8.07571C16.248 8.09927 16.6251 8.09997 17.2 8.09997H18.3272ZM14.4389 2.16628C14.1594 2.09918 13.8727 2.09954 13.5731 2.09991L13.5059 2.09997H10.6H10.5616C9.61407 2.09996 8.84832 2.09995 8.22789 2.15064C7.58861 2.20287 7.02478 2.31338 6.50242 2.57954C5.6745 3.00138 5.00139 3.67449 4.57955 4.50241C4.31339 5.02477 4.20288 5.58859 4.15065 6.22788C4.09996 6.8483 4.09997 7.61406 4.09998 8.56156V8.59997V15.4V15.4384C4.09997 16.3859 4.09996 17.1516 4.15065 17.772C4.20288 18.4113 4.31339 18.9752 4.57955 19.4975C5.00139 20.3254 5.6745 20.9986 6.50242 21.4204C7.02478 21.6866 7.58861 21.7971 8.22789 21.8493C8.84831 21.9 9.61407 21.9 10.5616 21.9H10.6H14.4H14.4384C15.3859 21.9 16.1516 21.9 16.7721 21.8493C17.4113 21.7971 17.9752 21.6866 18.4975 21.4204C19.3254 20.9986 19.9986 20.3254 20.4204 19.4975C20.6866 18.9752 20.7971 18.4113 20.8493 17.772C20.9 17.1516 20.9 16.3859 20.9 15.4384V15.4V9.49408L20.9 9.42687C20.9004 9.12725 20.9008 8.84049 20.8337 8.56102C20.7749 8.31613 20.6779 8.08202 20.5463 7.86729C20.3961 7.62223 20.1931 7.41972 19.981 7.20812L19.9334 7.16062L15.8393 3.06651L15.7918 3.01895C15.5802 2.80682 15.3777 2.6038 15.1327 2.45363C14.9179 2.32204 14.6838 2.22507 14.4389 2.16628Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const uploadCloudOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M12 20.5C12.4734 20.5 12.8571 20.1162 12.8571 19.6429V10.5693L14.8225 12.5347C15.1572 12.8694 15.6999 12.8694 16.0346 12.5347C16.3694 12.1999 16.3694 11.6572 16.0346 11.3225L12.6061 7.89391C12.2713 7.55917 11.7286 7.55917 11.3939 7.89391L7.96532 11.3225C7.63058 11.6572 7.63058 12.1999 7.96532 12.5347C8.30005 12.8694 8.84277 12.8694 9.1775 12.5347L11.1428 10.5693V19.6429C11.1428 20.1162 11.5266 20.5 12 20.5Z'
        fill='#023F80'
      />
      <path
        d='M13.7857 2.57153C12.3178 2.57153 10.9397 3.13929 9.92266 4.12361C8.65989 3.77076 7.35895 4.08968 6.38884 4.79247C5.42506 5.49068 4.72751 6.61392 4.71391 7.92196C3.4259 8.60162 2.57141 9.93256 2.57141 11.4376C2.57141 13.6745 4.46797 15.3659 6.6047 15.4283L8.57141 15.4287C9.0448 15.4287 9.42855 15.0449 9.42855 14.5715C9.42855 14.0981 9.0448 13.7144 8.57141 13.7144H6.64314C5.32891 13.6701 4.2857 12.6376 4.2857 11.4376C4.2857 10.4672 4.92426 9.5969 5.88244 9.28167C6.28579 9.14898 6.53119 8.74097 6.45937 8.32248C6.31306 7.46993 6.70407 6.68097 7.39457 6.18074C8.08919 5.67753 9.00371 5.53026 9.80393 5.90131C10.1582 6.06557 10.5786 5.96965 10.8266 5.66803C11.537 4.80388 12.6136 4.28582 13.7857 4.28582C16.0323 4.28582 17.7931 6.26493 17.5472 8.3732C17.5002 8.77644 17.7425 9.15736 18.1277 9.28568C19.0803 9.60306 19.7143 10.4707 19.7143 11.4376C19.7143 12.6357 18.7416 13.6544 17.4692 13.7119H15.4286C14.9552 13.7119 14.5714 14.0956 14.5714 14.569C14.5714 15.0424 14.9552 15.4262 15.4286 15.4262C16.1326 15.4262 17.5471 15.4244 17.5471 15.4244C19.6968 15.3273 21.4286 13.5904 21.4286 11.4376C21.4286 9.93264 20.574 8.60089 19.2848 7.92166C19.2572 5.02638 16.7929 2.57153 13.7857 2.57153Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const uploadOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M11.3637 2.36358C11.7152 2.01211 12.285 2.01211 12.6365 2.36358L18.6365 8.36358C18.988 8.71505 18.988 9.2849 18.6365 9.63637C18.285 9.98784 17.7152 9.98784 17.3637 9.63637L12.9001 5.17277V16C12.9001 16.497 12.4972 16.9 12.0001 16.9C11.503 16.9 11.1001 16.497 11.1001 16V5.17277L6.63649 9.63637C6.28502 9.98784 5.71517 9.98784 5.3637 9.63637C5.01223 9.2849 5.01223 8.71505 5.3637 8.36358L11.3637 2.36358ZM4.1001 20C4.1001 19.5029 4.50304 19.1 5.0001 19.1H19.0001C19.4972 19.1 19.9001 19.5029 19.9001 20C19.9001 20.497 19.4972 20.9 19.0001 20.9H5.0001C4.50304 20.9 4.1001 20.497 4.1001 20Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const downloadOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M12 2C12.4971 2 12.9 2.40294 12.9 2.9V13.8272L17.4636 9.26361C17.8151 8.91214 18.3849 8.91214 18.7364 9.26361C19.0879 9.61508 19.0879 10.1849 18.7364 10.5364L12.6364 16.6364C12.2849 16.9879 11.7151 16.9879 11.3636 16.6364L5.26361 10.5364C4.91214 10.1849 4.91214 9.61508 5.26361 9.26361C5.61508 8.91214 6.18493 8.91214 6.5364 9.26361L11.1 13.8272V2.9C11.1 2.40294 11.5029 2 12 2ZM4 20C4 19.5029 4.40294 19.1 4.9 19.1H19.1C19.5971 19.1 20 19.5029 20 20C20 20.4971 19.5971 20.9 19.1 20.9H4.9C4.40294 20.9 4 20.4971 4 20Z'
        fill='#023F80'
      />
    </svg>
  );
};

/** Mismo ícono que el botón de exportar en Carga de balance (DualBalanceLoader): documento con flecha de descarga */
export const documentDownloadOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 2V8H20'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 12V18'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 15L12 18L15 15'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const cloudOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M12.5 6C9.46243 6 7 8.46243 7 11.5C7 11.7564 7.01748 12.0083 7.05119 12.2544C7.11256 12.7026 6.86549 13.1361 6.44865 13.3117C5.00818 13.9185 4 15.3427 4 17C4 19.2091 5.79086 21 8 21H19C21.7614 21 24 18.7614 24 16C24 13.2386 21.7614 11 19 11C18.9515 11 18.9031 11.0007 18.855 11.0021C18.3807 11.0155 17.9622 10.6938 17.8533 10.232C17.2811 7.8053 15.1002 6 12.5 6ZM5 11.5C5 7.35786 8.35786 4 12.5 4C15.7753 4 18.5584 6.09869 19.5813 9.02379C23.1753 9.31924 26 12.3298 26 16C26 19.866 22.866 23 19 23H8C4.68629 23 2 20.3137 2 17C2 14.7754 3.21048 12.8354 5.00589 11.7996C5.00197 11.7001 5 11.6003 5 11.5Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const sendOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.89104 9.77081L4.89104 9.7708C4.32866 8.33216 3.93241 7.21464 3.75607 6.49728C3.73131 6.39657 3.70573 6.29413 3.68024 6.19206C3.60261 5.88126 3.52585 5.57392 3.47603 5.32967C3.44166 5.16117 3.40395 4.94891 3.39036 4.72919C3.37894 4.54457 3.3671 4.1436 3.54391 3.71155C3.77374 3.14994 4.2579 2.69666 4.90746 2.54158C5.40587 2.42258 5.8338 2.52284 6.03023 2.5771C6.44301 2.69111 6.88711 2.91987 7.24999 3.11429C8.28937 3.67117 12.3279 5.7877 15.401 7.39832C16.833 8.1488 18.0554 8.78944 18.6671 9.11128C18.7432 9.15131 18.8188 9.19098 18.8937 9.23024C19.392 9.49162 19.8557 9.7349 20.1922 9.94548C20.3853 10.0663 20.6452 10.2415 20.8739 10.4739C21.0936 10.6971 21.484 11.1751 21.5127 11.8937C21.5425 12.6396 21.1668 13.1593 20.9292 13.4154C20.696 13.6668 20.4282 13.8489 20.2425 13.9665C19.93 14.1643 19.499 14.391 19.0524 14.6259C18.9674 14.6706 18.8819 14.7156 18.7965 14.7608C18.336 15.0042 17.4592 15.4689 16.382 16.0398C13.2668 17.6907 8.47539 20.2299 7.22873 20.8766C6.83785 21.0793 6.38179 21.3079 5.97469 21.4211C5.79098 21.4721 5.34293 21.5838 4.82343 21.4525C4.1102 21.2721 3.63291 20.7423 3.44398 20.1534C3.30449 19.7187 3.34353 19.3253 3.36298 19.1615C3.38733 18.9564 3.43187 18.7549 3.46989 18.5964C3.50691 18.442 3.55229 18.2701 3.596 18.1044L3.60497 18.0704C3.65338 17.8869 3.70403 17.6941 3.75607 17.4824C3.92998 16.7749 4.32016 15.668 4.87415 14.2401C5.23316 13.3148 5.85864 12.5437 6.64528 11.9954C5.86779 11.45 5.24892 10.6863 4.89104 9.77081ZM9.08523 11.0824C9.17635 11.1002 9.30344 11.1253 9.4575 11.156C9.55417 11.1752 9.66146 11.1967 9.77713 11.2198C9.8822 11.2409 9.98237 11.2609 10.0777 11.2802C11.0065 11.4674 11.4801 11.5761 11.5835 11.7457C11.6813 11.9063 11.6806 12.109 11.5818 12.2689C11.4773 12.4379 11.003 12.5435 10.0731 12.7247C9.97763 12.7433 9.87741 12.7627 9.77229 12.783C9.65661 12.8054 9.54905 12.8262 9.45175 12.8449C9.30018 12.8741 9.17354 12.8984 9.07997 12.9162C9.02653 12.9263 8.98388 12.9343 8.95353 12.9399C7.85409 13.1422 6.94388 13.8818 6.55228 14.8912C6.06296 16.1524 5.73367 17.0835 5.56442 17.6844C5.54131 17.7665 5.52117 17.8423 5.50403 17.9121C5.50301 17.9162 5.50199 17.9204 5.50097 17.9245C5.44334 18.1584 5.38781 18.3689 5.33838 18.5563C5.00498 19.82 4.94925 20.0312 6.39992 19.2788C6.52241 19.2152 6.67942 19.1333 6.86594 19.0355C6.94151 18.9959 7.02192 18.9537 7.10685 18.9092C8.93217 17.9507 12.8412 15.8791 15.5236 14.4575C16.6068 13.8835 17.4899 13.4154 17.9552 13.1695C18.0697 13.1089 18.1788 13.0515 18.2823 12.997C18.2875 12.9942 18.2928 12.9915 18.298 12.9887C19.2335 12.496 19.712 12.2383 19.7143 11.9763C19.7167 11.7169 19.2524 11.4533 18.303 10.9533C18.2972 10.9503 18.2915 10.9473 18.2857 10.9442C18.1442 10.8697 17.992 10.79 17.8291 10.7043C17.2246 10.3862 16.0115 9.75047 14.587 9.0039C12 7.64808 8.71572 5.92684 7.1133 5.07976C7.04329 5.04275 6.97648 5.0074 6.91309 4.97383C6.70166 4.86187 6.52814 4.76962 6.39992 4.70092C4.97236 3.93607 5.03861 4.20142 5.41714 5.71767C5.44461 5.8277 5.47373 5.94431 5.50403 6.06759C5.5051 6.07196 5.50619 6.07635 5.50729 6.08076C5.52208 6.14032 5.53899 6.20417 5.558 6.27232C5.56013 6.27995 5.56228 6.28763 5.56446 6.29537C5.7358 6.90312 6.07015 7.84315 6.5675 9.11546C6.96047 10.1207 7.86823 10.857 8.96411 11.0593C8.99098 11.0642 9.03195 11.0721 9.08523 11.0824Z'
        fill='#023F80'
      />
    </svg>
  );
};
